import React from 'react'
import { useSelector } from 'react-redux'
import { getListState } from 'data'

import { getListName } from '../Loaders/dataSync/fetchesArchivedNotes'

export const ArchivedNotesPlaceholder = () => {
  const archivedNotesRootLoadingState = useSelector(state =>
    getListState(getListName())(state)
  )

  if (
    archivedNotesRootLoadingState.pristine ||
    archivedNotesRootLoadingState.loading
  ) {
    return null
  }

  return (
    <div className="margin-left-large margin-vertical-small padding-medium background-shade-50 radius-normal margin-right-normal">
      <p className="margin-bottom-normal normal font-weight-medium">
        Docs you archive will be sent here.
      </p>
      <p>You can permanently delete archived docs here too.</p>
    </div>
  )
}
